import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ComboCard } from '@/components/ComboCard';
export function CatalogComboSection({ combos, combosLoading, getComboQuantity, onSelectCombo, onAddToCart, onIncrement, onDecrement, }) {
    if (combosLoading) {
        return _jsx("p", { className: "catalog__message", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026" });
    }
    if (combos.length === 0) {
        return _jsx("p", { className: "catalog__message", children: "\u041D\u0435\u0442 \u043A\u043E\u043C\u0431\u043E-\u043D\u0430\u0431\u043E\u0440\u043E\u0432 \u0432 \u044D\u0442\u043E\u043C \u043C\u0435\u043D\u044E." });
    }
    return (_jsx(_Fragment, { children: combos.map((combo) => (_jsx(ComboCard, { combo: combo, cartQuantity: getComboQuantity(combo.id), onCardClick: onSelectCombo, onAddToCart: () => onAddToCart(combo), onIncrement: () => onIncrement(combo.id), onDecrement: () => onDecrement(combo.id) }, combo.id))) }));
}
